module.exports = __webpack_public_path__ + "img/dibulogo.d6ac31b4.png";